/**
 * Filter Loading Mixin
 *
 * Provides loading state for views with filters.
 * Works in conjunction with the Filters component to show loading feedback.
 *
 * Usage:
 * 1. Import this mixin in your component
 * 2. Add it to the mixins array
 * 3. Pass the 'filtersLoading' data property to your Filters component as :loading prop
 * 4. Wrap your tableRows() method with filtersLoading state management
 *
 * Example:
 * import filterLoadingMixin from '@/mixins/filterLoadingMixin';
 *
 * export default {
 *   name: 'MyComponent',
 *   mixins: [filterLoadingMixin],
 *   methods: {
 *     async tableRows() {
 *       if (this.filtersLoading) return;
 *       this.filtersLoading = true;
 *       try {
 *         // your API calls
 *       } finally {
 *         this.filtersLoading = false;
 *       }
 *     }
 *   }
 * }
 */

export default {
  data() {
    return {
      filtersLoading: false,
    };
  },
};
